import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import apiClient from '@/apiClient'
import type { CreateUserBody, UpdateUserBody, UserRow } from '@/types/backend'

export const useUsersQuery = (enabled = true) => {
  return useQuery({
    queryKey: ['users'],
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<UserRow[]>(`/users`)
      return data
    },
  })
}

export const useCreateUserMutation = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreateUserBody) => {
      const { data } = await apiClient.post<UserRow>(`/users`, payload)
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['users'], exact: false })
      qc.invalidateQueries({ queryKey: ['me'] })
    },
  })
}

export const useUpdateUserMutation = (id: string) => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (payload: UpdateUserBody) => {
      const { data } = await apiClient.patch<UserRow>(`/users/${id}`, payload)
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['users'], exact: false })
      qc.invalidateQueries({ queryKey: ['me'] })
    },
  })
}

export const useDeleteUserMutation = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await apiClient.delete(`/users/${id}`)
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['users'], exact: false })
      qc.invalidateQueries({ queryKey: ['me'] })
    },
  })
}
